import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { EventColors } from "src/app/models/event-colors";
import { EventDataService } from "src/app/shared/services/eventData/event-data.service";
import { ModalController } from "@ionic/angular";
import { DocumentViewerComponent } from "src/app/shared/components/documents/document-viewer/document-viewer.component";

@Component({
    selector: "app-documents",
    templateUrl: "./documents.component.html",
    styleUrls: ["./documents.component.scss"],
})
/** @deprecated Use the new modular document components from DocumentsSharedModule (DocumentListComponent, DocumentCardComponent, etc.) instead. This component is kept for backward compatibility. */
export class DocumentsComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];

    @Input() eventId: string;
    @Input() showTitle: boolean = false;
    @Input() widthImg: number = 32;
    @Input() showNoResultImage: boolean = false;
    @Input() documents: any[] = [];

    eventColors: EventColors = new EventColors();
    language: string;

    constructor(
        private SEventData: EventDataService,
        private modalCtrl: ModalController,
    ) { }

    ngOnInit() {
        this.language = this.SEventData.getLanguage();
        this.loadColors();
    }

    async openDocument(document) {
        const modal = await this.modalCtrl.create({
            component: DocumentViewerComponent,
            componentProps: {
                document: document,
                eventId: this.eventId,
            },
            cssClass: 'document-viewer-modal',
        });
        await modal.present();
    }

    loadColors(eventId: string = this.eventId) {
        const subscription = this.SEventData.getEventDataListener(eventId).subscribe((eventData) => {
            this.eventColors = eventData.colors;
        });
        this.subscriptions.push(subscription);
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
